var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgL2Dkdk = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_2290)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E9EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.25 38H-0.75V51H50.25V38Z",
    fill: "url(#paint0_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 12.75L21.5 14.25L20 19.5V26.25L27.5 25.5H36.5L37.25 20.25L36.5 14.25L29.75 12.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25 10.5H22.25C20.04 10.5 18.25 12.28 18.25 14.47V24.53C18.25 26.72 20.04 28.5 22.25 28.5H34.25C36.46 28.5 38.25 26.72 38.25 24.53V14.47C38.25 12.28 36.46 10.5 34.25 10.5ZM24.75 14.67C26.02 14.67 27.06 15.71 27.06 16.98C27.06 18.25 26.02 19.29 24.75 19.29C23.48 19.29 22.44 18.25 22.44 16.98C22.44 15.71 23.48 14.67 24.75 14.67ZM28.62 24.16C28.53 24.26 28.39 24.32 28.25 24.32H21.25C21.11 24.32 20.97 24.26 20.88 24.16C20.79 24.06 20.74 23.92 20.75 23.78C20.92 22.1 22.26 20.77 23.94 20.61C24.47 20.56 25.02 20.56 25.55 20.61C27.23 20.77 28.58 22.1 28.74 23.78C28.76 23.92 28.71 24.06 28.62 24.16ZM35.25 24.25H33.25C32.84 24.25 32.5 23.91 32.5 23.5C32.5 23.09 32.84 22.75 33.25 22.75H35.25C35.66 22.75 36 23.09 36 23.5C36 23.91 35.66 24.25 35.25 24.25ZM35.25 20.25H31.25C30.84 20.25 30.5 19.91 30.5 19.5C30.5 19.09 30.84 18.75 31.25 18.75H35.25C35.66 18.75 36 19.09 36 19.5C36 19.91 35.66 20.25 35.25 20.25ZM35.25 16.25H30.25C29.84 16.25 29.5 15.91 29.5 15.5C29.5 15.09 29.84 14.75 30.25 14.75H35.25C35.66 14.75 36 15.09 36 15.5C36 15.91 35.66 16.25 35.25 16.25Z",
    fill: "url(#paint1_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6375 31.7586L15.1495 33.569L17.7092 33.8276L22.3168 33.3103L15.6614 33.0517L15.4055 31.5H22.5728L23.8526 30.9828L25.3885 30.4655L29.7401 30.7241V32.5345H28.7162L24.8765 32.7931L24.6206 33.8276L29.7401 33.0517V34.3448L29.2281 34.8621L23.3407 35.8966L14.3816 35.1207H10.286L8.75012 34.3448V33.0517L9.0061 33.3103L12.3338 33.569L13.8696 33.8276L13.6136 32.7931H12.5897L11.3099 32.5345L9.77402 32.2759L8.75012 31.7586V30.9423L9.26207 29.9483L9.51805 30.7241L10.5419 30.9828L13.1017 31.2414L14.6375 31.7586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5633 24.9769L12.8458 28.6551H26.1565L24.0096 24.9769L19.2865 24.5171L14.5633 24.9769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8457 28.6552H10.7979C10.5153 28.6552 10.286 28.4234 10.286 28.1379C10.286 27.8524 10.5153 27.6207 10.7979 27.6207H12.8457C13.1283 27.6207 13.3577 27.8524 13.3577 28.1379C13.3577 28.4234 13.1283 28.6552 12.8457 28.6552Z",
    fill: "url(#paint2_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2312 29.6894C26.046 29.6894 25.874 29.5604 25.8146 29.3585C25.6775 28.8872 24.1624 25.6784 23.8 25.337C23.4612 25.1682 20.741 24.9482 19.2451 24.9482C17.7492 24.9482 15.029 25.1682 14.6596 25.3598C14.3269 25.6784 12.8127 28.8872 12.6756 29.3585C12.6031 29.6078 12.3594 29.7463 12.1272 29.6676C11.8975 29.5879 11.7691 29.3215 11.8425 29.0721C11.9254 28.7885 13.5916 24.9539 14.2151 24.5433C14.864 24.1147 18.7456 24 19.2451 24C19.7446 24 23.6262 24.1147 24.2751 24.5433C24.8986 24.9549 26.5648 28.7885 26.6477 29.0721C26.7211 29.3215 26.5927 29.5879 26.3639 29.6676C26.3194 29.6828 26.2748 29.6894 26.2312 29.6894Z",
    fill: "url(#paint3_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8969 36.6724C12.6813 36.6724 12.508 36.7997 12.4583 36.968L9.67163 36.3815V36.2845C9.67163 36.0703 9.46521 35.8966 9.21088 35.8966C8.95654 35.8966 8.75012 36.0703 8.75012 36.2845V37.8362C8.75012 38.4778 9.3703 39 10.1324 39H11.9754C12.7375 39 13.3577 38.4778 13.3577 37.8362V37.0603C13.3577 36.8462 13.1513 36.6724 12.8969 36.6724Z",
    fill: "url(#paint4_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2793 35.8966C29.025 35.8966 28.8186 36.0703 28.8186 36.2845V36.3815L26.0319 36.968C25.9822 36.7997 25.8089 36.6724 25.5933 36.6724C25.3389 36.6724 25.1325 36.8462 25.1325 37.0603V37.8362C25.1325 38.4778 25.7527 39 26.5148 39H28.3578C29.1199 39 29.7401 38.4778 29.7401 37.8362V36.2845C29.7401 36.0703 29.5337 35.8966 29.2793 35.8966Z",
    fill: "url(#paint5_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6923 28.6552H25.6445C25.3619 28.6552 25.1325 28.4234 25.1325 28.1379C25.1325 27.8524 25.3619 27.6207 25.6445 27.6207H27.6923C27.9749 27.6207 28.2042 27.8524 28.2042 28.1379C28.2042 28.4234 27.9749 28.6552 27.6923 28.6552Z",
    fill: "url(#paint6_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7401 33.427C29.7392 32.7809 29.7631 32.2293 29.7401 31.7586L28.5436 32.0247C28.4003 32.05 25.5346 32.5217 24.8084 32.5217C24.7042 32.6162 24.6104 33.2419 24.6215 33.8276C27.2226 33.6873 29.2477 33.5011 29.2801 33.4982L29.7401 33.427Z",
    fill: "url(#paint7_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62415 31.1808C9.6383 31.1808 12.524 31.6109 13.498 31.6109C13.8324 31.6109 14.127 31.7385 14.3499 31.9797C14.8188 32.4878 14.8409 33.378 14.8294 33.7247C16.2528 33.7841 17.7894 33.8276 19.2482 33.8276C20.7087 33.8276 22.2463 33.7841 23.6714 33.7247C23.6617 33.3328 23.6838 32.3512 24.1217 31.8875C24.2933 31.7066 24.5101 31.6109 24.7507 31.6109C25.323 31.6109 27.6328 31.2943 28.4741 31.1719L29.7401 30.9828C29.7401 29.9483 29.4437 29.9536 29.104 29.8543C28.9059 29.7967 28.8023 29.6521 28.606 29.3578L28.4547 29.1361C28.1902 28.7663 27.6789 28.7503 27.1843 28.7362C27.0357 28.7317 26.8004 28.7246 26.6889 28.6989C26.6509 28.643 26.5996 28.5961 26.5377 28.5624C25.7123 28.1075 22.5851 27.6207 19.2482 27.6207C15.9113 27.6207 12.7841 28.1075 11.9587 28.5624C11.8968 28.5961 11.8455 28.643 11.8066 28.6998C11.6951 28.7255 11.4598 28.7326 11.3112 28.737C10.8175 28.7512 10.3062 28.7663 10.0417 29.1361L9.89043 29.3586C9.69404 29.653 9.59053 29.7976 9.39237 29.8552C9.04559 29.9572 8.85539 30.3136 8.75012 30.9618L9.62415 31.1808ZM16.1519 32.0542H22.3444C22.5886 32.0542 22.7868 32.2528 22.7868 32.4975C22.7868 32.7423 22.5886 32.9409 22.3444 32.9409H16.1519C15.9078 32.9409 15.7096 32.7423 15.7096 32.4975C15.7096 32.2528 15.9078 32.0542 16.1519 32.0542Z",
    fill: "url(#paint8_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3825 34.3928C29.3062 34.3989 23.8834 34.8323 19.2451 34.8323C14.6068 34.8323 9.18398 34.3989 9.13051 34.3954L8.75012 34.3562C8.79745 35.3023 8.94382 36.721 9.39784 36.9617C9.87114 37.212 15.3465 37.4483 19.2451 37.4483C23.1437 37.4483 28.6191 37.212 29.0915 36.9608C29.5472 36.7193 29.6936 35.2909 29.7401 34.3448L29.3825 34.3928Z",
    fill: "url(#paint9_linear_174_2290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8686 33.8276C13.8771 33.4662 13.8362 32.8366 13.6341 32.5804C13.5812 32.5133 13.525 32.4863 13.4397 32.4863C12.4336 32.4863 9.65734 32.0009 9.53968 31.9808L8.77996 31.7586C8.75865 32.2331 8.75097 32.7886 8.75012 33.4322L9.21993 33.4893C9.24722 33.4923 11.2697 33.6824 13.8686 33.8276Z",
    fill: "url(#paint10_linear_174_2290)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_174_2290",
    x1: 24.75,
    y1: 38,
    x2: 24.75,
    y2: 51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_174_2290",
    x1: 28.25,
    y1: 10.5,
    x2: 28.25,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_174_2290",
    x1: 8.75012,
    y1: 30.375,
    x2: 29.7501,
    y2: 30.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_2290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL2Dkdk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L2dkdk.a05c905a.svg";
export { ForwardRef as ReactComponent };